import { Shimmer } from '@wartek-id/shimmer'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'

import { useApiGetRencanaTindakLanjut } from 'api/kinerja/gpk/pelaksanaan'

import type { MultiPeriodPayload } from 'types/kinerja'

type PelatihanMandiriListProps = {
  periodParams: MultiPeriodPayload
  ptkId?: string
}

export function PelatihanMandiriList({
  periodParams,
  ptkId,
}: PelatihanMandiriListProps) {
  // -----------------------------------------
  // Get Rencana Tindak Lanjut data
  // -----------------------------------------
  const {
    isLoading: isRencanaTindakLanjutLoading,
    data: rencanaTindakLanjutData,
  } = useApiGetRencanaTindakLanjut({
    params: {
      skpYear: periodParams.skpYear,
      skpPeriod: periodParams.skpPeriod,
      ptkId,
    },
    options: {
      useErrorBoundary: false,
      staleTime: 60 * 60 * 1000, // 1 hour
    },
  })

  if (isRencanaTindakLanjutLoading) {
    return <Shimmer height={100} width="100%" noOfLines={3} />
  }

  return (
    <ul className="space-y-2">
      {rencanaTindakLanjutData?.data?.detail?.followUpTargets?.map((item) => {
        const showLink = !ptkId && item?.learningModule?.url

        return (
          <li
            key={item.id}
            className="flex justify-between items-center gap-4 border border-subdued rounded p-3"
          >
            <div className="space-y-1">
              <Text as="h4" variant="heading-sm">
                {item.learningModule?.title}
              </Text>

              <Text color="subdued">{item.subIndicator}</Text>
            </div>
            {showLink && (
              <Button
                type={undefined}
                color="blue"
                size="lg"
                as="a"
                href={item?.learningModule?.url ?? ''}
                target="_blank"
                rel="noreferrer"
                className="whitespace-nowrap"
              >
                Pelajari modul <Icon color="inverse">chevron_right</Icon>
              </Button>
            )}
          </li>
        )
      })}
    </ul>
  )
}
